import React, { useState } from "react";
import logov from "../../img/logov-01.svg";
import file from "../../img/file.svg";
import { NavLink, Link } from "react-router-dom";

import "./navbar.scss";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const Toggle = () => {
    setToggle(!toggle);
  };

  return (
    <nav className='bg-gray-800 px-8 pt-2 shadow-md' role='navigation'>
      <div className='container mx-auto p-4 flex flex-wrap items-center md:flex-no-wrap'>
        <a href='/' rel='home' className='flex mr-4 md:mr-8'>
          <img src={file} className='h-12 mr-2 w-12' alt='logo' />

          <div className='logo text-gray-300 text-3xl font-black'>
            VALORANT TRACKER
          </div>
        </a>

        <div
          className={
            toggle
              ? "ml-auto navBar navBar-active lg:hidden"
              : "ml-auto navBar lg:hidden"
          }
        >
          <button onClick={Toggle} class='lg:hidden focus:outline-none '>
            <svg fill='currentColor' viewBox='0 0 20 20' class='w-6 h-6'>
              <path
                fill='white'
                d='M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z'
                clip-rule='evenodd'
              ></path>
            </svg>
          </button>
          <div className={toggle ? "" : "hidden"}>
            <div class='navbarbox text-gray-500 hover:text-white'>
              <NavLink exact to='/' activeClassName='text-white'>
                <div className=' flex justify-center items-center p-5 uppercase text-xl  btnNavbar btn-Navbar'>
                  <span>Home</span>
                </div>
              </NavLink>
            </div>
            <div class='navbarbox text-gray-500 hover:text-white'>
              <NavLink exact to='/agents' activeClassName='text-white'>
                <div className=' flex justify-center items-center p-5 uppercase text-xl  btnNavbar btn-Navbar'>
                  <span>Agents</span>
                </div>
              </NavLink>
            </div>
            <div class='navbarbox text-gray-500 hover:text-white'>
              <NavLink exact to='/weapons' activeClassName='text-white'>
                <div className=' flex justify-center items-center p-5 uppercase text-xl  btnNavbar btn-Navbar'>
                  <span>Weapons</span>
                </div>
              </NavLink>
            </div>
            <div class='navbarbox text-gray-500 hover:text-white'>
              <NavLink exact to='/maps' activeClassName='text-white'>
                <div className=' flex justify-center items-center p-5 uppercase text-xl  btnNavbar btn-Navbar'>
                  <span>Maps</span>
                </div>
              </NavLink>
            </div>
          </div>
        </div>

        <div class='-mb-4  hidden lg:flex text-gray-100 justify-center'>
          <div class='navbarbox text-gray-500 hover:text-white'>
            <NavLink exact to='/' activeClassName='text-white'>
              <div className=' flex justify-center items-center p-5 uppercase text-xl  btnNavbar btn-Navbar'>
                <span>Home</span>
              </div>
            </NavLink>
          </div>
          <div class='navbarbox text-gray-500 hover:text-white'>
            <NavLink exact to='/agents' activeClassName='text-white'>
              <div className=' flex justify-center items-center p-5 uppercase text-xl  btnNavbar btn-Navbar'>
                <span>Agents</span>
              </div>
            </NavLink>
          </div>
          <div class='navbarbox text-gray-500 hover:text-white'>
            <NavLink exact to='/weapons' activeClassName='text-white'>
              <div className=' flex justify-center items-center p-5 uppercase text-xl  btnNavbar btn-Navbar'>
                <span>Weapons</span>
              </div>
            </NavLink>
          </div>
          <div class='navbarbox text-gray-500 hover:text-white'>
            <NavLink exact to='/maps' activeClassName='text-white'>
              <div className=' flex justify-center items-center p-5 uppercase text-xl  btnNavbar btn-Navbar'>
                <span>Maps</span>
              </div>
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
